import { useState } from 'react';
import { useThrottledCallback } from 'use-debounce';
import { AxiosProgressEvent } from 'axios';

export type Progress = {
  progress: number;
  finishedFiles: number;
  totalFiles: number;
  files: Record<string, number>;
};

export const useDownloadProgress = () => {
  const [progress, setProgress] = useState<Progress>({
    progress: 0,
    finishedFiles: 0,
    totalFiles: 0,
    files: {},
  });

  const updateProgress = useThrottledCallback((arg: UpdateProgressArgs, name: string) => {
    const { axiosProgressEvent, zippingProgress } = arg;

    setProgress((s) => {
      const files = {
        ...s.files,
        ...{ [name]: axiosProgressEvent ? (axiosProgressEvent.progress ?? 100) / 2 : 0.5 + zippingProgress / 2 },
      };

      return {
        ...s,
        files,
        finishedFiles: s.finishedFiles + (zippingProgress === 1 ? 1 : 0),
        progress: Object.values(files).reduce((acc, next) => acc + next, 0) / s.totalFiles,
      };
    });
  }, 300);

  const resetProgress = (totalFiles: number) =>
    setProgress({
      finishedFiles: 0,
      progress: 0,
      files: {},
      totalFiles,
    });

  return {
    progress,
    updateProgress,
    resetProgress,
  };
};

export type UpdateProgressArgs =
  | { axiosProgressEvent: AxiosProgressEvent; zippingProgress?: undefined }
  | { axiosProgressEvent?: undefined; zippingProgress: number };
